import React, { PureComponent } from 'react'

import InlineSVG from 'svg-inline-react'

export default class CheckedIcon extends PureComponent
{
	render ()
	{
		const component = this, props = this.props, state = this.state;

		const svg_source =
		(
			`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1024 1024">

				<path fill="inherit" d="M1005.741 150.947c-24.402-24.408-63.904-24.41-88.308-0.002l-589.653 589.653-221.212-221.212c-24.402-24.408-63.904-24.41-88.308-0.002-24.346 24.348-24.346 63.962 0 88.306l265.369 265.371c24.398 24.396 63.906 24.4 88.306 0l633.807-633.809c24.344-24.346 24.344-63.962 0-88.304z" />
				<path fill="currentColor" d="M1005.741 150.947c-24.402-24.408-63.904-24.41-88.308-0.002l-430.411 430.411v176.612l518.719-518.717c24.344-24.346 24.344-63.962 0-88.304z" />

			</svg>`
		);

		let output =
		(
			<InlineSVG src={ svg_source } className={ props.className }
				raw={ true }
			/>
		);

		return output;
	}
}
